import _ from 'lodash';
import { handleResponse, handleError } from './api-utils';

export function submitDotMailerTrackData(dotMailerUserEntries, callBackUrl) {
    const copyOfDotMailerUserEntries = _.cloneDeep(dotMailerUserEntries);

    if (copyOfDotMailerUserEntries.length > 500) {
        const splitEntries = [];
        while (copyOfDotMailerUserEntries.length) {
            splitEntries.push(copyOfDotMailerUserEntries.splice(0, 500));
        }

        const promises = [];
        splitEntries.forEach((splitEntry) => {
            promises.push(saveData(splitEntry, callBackUrl));
        });
        return Promise.all(promises);
    }

    return saveData(copyOfDotMailerUserEntries, callBackUrl);
}

function saveData(dotMailerUserEntries, callBackUrl) {
    return fetch(callBackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ dotMailerTrackData: dotMailerUserEntries })
    })
        .then(handleResponse)
        .catch(handleError);
}
